/* MagSert — HOW IT WORKS split simulation.
   Two live pipes (without / with MagSert), scoped hiw- ids, vanilla canvas, no deps.
   Tier B enhancement (spec docs/superpowers/specs/2026-07-01): water streamlines,
   faceted crystals, accumulating crust + buildup gauges, conversion ripples,
   toggle idle hint, staged power-on for pipe B, loop pauses out of viewport.
   Toggle readout/state strings come from data-attributes so they stay editable in
   the theme editor. Starts on scroll via IntersectionObserver; static SVG fallback
   carries the story under prefers-reduced-motion.

   Wrapped in initHIW() and guarded so it works on first load AND on
   shopify:section:load when the merchant edits the section. */
(function () {
  function initHIW() {
    var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
    var cvA = document.getElementById('hiw-cv-a');
    var cvB = document.getElementById('hiw-cv-b');
    if (reduce || !cvA || !cvB) return; // static fallback carries the story
    if (cvA.dataset.hiwInit === '1') return; // already running
    cvA.dataset.hiwInit = '1';

    function lerpCol(a, b, t) {
      var ar = (a >> 16) & 255, ag = (a >> 8) & 255, ab = a & 255,
          br = (b >> 16) & 255, bg = (b >> 8) & 255, bb = b & 255;
      return 'rgb(' + (((ar + (br - ar) * t) | 0)) + ',' + (((ag + (bg - ag) * t) | 0)) + ',' + (((ab + (bb - ab) * t) | 0)) + ')';
    }
    function rrect(c, x, y, w, h, r) {
      r = Math.min(r, Math.abs(w) / 2, Math.abs(h) / 2); c.beginPath();
      c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath();
    }
    function easeOut(t) { var u = 1 - t; return 1 - u * u * u; }

    var BUCKET = 8, CRUST_MAX = 14, CRUST_FULL = 10;

    function makeSim(cv, hasUnit, powerDelay) {
      var ctx = cv.getContext('2d');
      var W = 0, H = 0, fieldX = 0, wallTop = 0, wallBot = 0;
      var crystals = [], stuck = [], streams = [], ripples = [];
      var crustTop = [], crustBot = [];
      var spawnAcc = 0, tSim = 0, fieldGlow = 0, gaugeV = 0;
      var on = hasUnit; var FIELD_R = 38;

      function resize() {
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        W = cv.clientWidth; H = cv.clientHeight;
        cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        wallTop = H * 0.16; wallBot = H * 0.84; fieldX = W * 0.2;
        var n = Math.ceil(W / BUCKET) || 0;
        while (crustTop.length < n) crustTop.push(0);
        while (crustBot.length < n) crustBot.push(0);
        crustTop.length = n; crustBot.length = n;
        streams.length = 0;
        for (var i = 0; i < 5; i++) {
          streams.push({
            x: Math.random() * W,
            y: wallTop + 12 + Math.random() * (wallBot - wallTop - 24),
            len: 40 + Math.random() * 50,
            v: 85 + Math.random() * 40,
            a: 0.08 + Math.random() * 0.08
          });
        }
      }
      function spawn() {
        var y = wallTop + 12 + Math.random() * (wallBot - wallTop - 24);
        crystals.push({
          x: -14, y: y, vx: 55 + Math.random() * 35,
          rot: Math.random() * Math.PI, seed: Math.random() * 6.28,
          size: 10 + Math.random() * 4, nLen: 18 + Math.random() * 8,
          treated: false, morph: 0,
          destWall: Math.random() < 0.5 ? 'top' : 'bot'
        });
      }
      function addCrust(x, wall) {
        var arr = wall === 'top' ? crustTop : crustBot;
        if (!arr.length) return;
        var i = Math.max(0, Math.min(arr.length - 1, (x / BUCKET) | 0));
        arr[i] = Math.min(CRUST_MAX, arr[i] + 3 + Math.random() * 2);
        if (i > 0) arr[i - 1] = Math.min(CRUST_MAX, arr[i - 1] + 1.2);
        if (i < arr.length - 1) arr[i + 1] = Math.min(CRUST_MAX, arr[i + 1] + 1.2);
        stuck.push({ x: x, wall: wall });
        if (stuck.length > 24) stuck.shift();
      }
      function drawCrust(arr, wall) {
        var y0 = wall === 'top' ? wallTop : wallBot;
        var dir = wall === 'top' ? 1 : -1;
        ctx.beginPath(); ctx.moveTo(0, y0);
        for (var i = 0; i < arr.length; i++) {
          var h = arr[i] < 0.5 ? 0 : arr[i];
          var e = h > 2 ? h + ((i % 3) - 1) * 1.2 : h;
          ctx.lineTo(i * BUCKET, y0 + dir * e);
          ctx.lineTo((i + 1) * BUCKET, y0 + dir * e);
        }
        ctx.lineTo(W, y0); ctx.closePath();
        ctx.fillStyle = '#B0742E'; ctx.fill();
        ctx.strokeStyle = '#8A571C'; ctx.lineWidth = 1; ctx.stroke();
      }
      function draw(dt) {
        tSim += dt;
        var powerT = powerDelay ? Math.max(0, Math.min(1, (tSim - powerDelay) / 0.6)) : 1;
        var conditioning = hasUnit && on && powerT >= 1;
        if (powerT >= 1) { spawnAcc += dt; while (spawnAcc > 0.16) { spawnAcc -= 0.16; spawn(); } }
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#E6EAEE'; ctx.fillRect(0, wallTop - 14, W, 14); ctx.fillRect(0, wallBot, W, 14);
        ctx.strokeStyle = '#C9D2DA'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(0, wallTop); ctx.lineTo(W, wallTop); ctx.moveTo(0, wallBot); ctx.lineTo(W, wallBot); ctx.stroke();

        // water streamlines — visible before the first crystal arrives
        ctx.lineCap = 'round';
        for (var si = 0; si < streams.length; si++) {
          var s = streams[si];
          s.x += s.v * dt;
          if (s.x - s.len > W) { s.x = -10; s.y = wallTop + 12 + Math.random() * (wallBot - wallTop - 24); }
          var g = ctx.createLinearGradient(s.x - s.len, 0, s.x, 0);
          g.addColorStop(0, 'rgba(14,143,166,0)');
          g.addColorStop(1, 'rgba(14,143,166,' + s.a.toFixed(3) + ')');
          ctx.strokeStyle = g; ctx.lineWidth = 2;
          ctx.beginPath(); ctx.moveTo(s.x - s.len, s.y); ctx.lineTo(s.x, s.y); ctx.stroke();
        }

        if (hasUnit) {
          fieldGlow = Math.max(0, fieldGlow - 2 * dt);
          var unitCol = on ? lerpCol(0x9B9AA6, 0x4140C8, powerT) : '#9b9aa6';
          ctx.fillStyle = (on && powerT > 0)
            ? 'rgba(65,64,200,' + ((0.10 + 0.10 * fieldGlow) * powerT).toFixed(3) + ')'
            : 'rgba(120,120,130,0.06)';
          ctx.fillRect(fieldX - FIELD_R, wallTop, FIELD_R * 2, wallBot - wallTop);
          ctx.strokeStyle = unitCol; ctx.lineWidth = 2.5;
          rrect(ctx, fieldX - 20, wallTop - 6, 40, (wallBot - wallTop) + 12, 9); ctx.stroke();
          ctx.fillStyle = unitCol;
          ctx.font = '10px IBM Plex Mono, monospace'; ctx.textAlign = 'center';
          ctx.fillText('MAGSERT', fieldX, wallTop - 12);
        }

        drawCrust(crustTop, 'top'); drawCrust(crustBot, 'bot');
        ctx.fillStyle = '#8A571C';
        for (var k = 0; k < stuck.length; k++) {
          var st = stuck[k];
          var bi = Math.max(0, Math.min(crustTop.length - 1, (st.x / BUCKET) | 0));
          var hh = st.wall === 'top' ? crustTop[bi] : crustBot[bi];
          var yy = st.wall === 'top' ? wallTop + hh : wallBot - hh - 8;
          ctx.fillRect(st.x - 4, yy, 8, 8);
        }

        if (ripples.length) {
          ctx.save(); ctx.beginPath(); ctx.rect(0, wallTop, W, wallBot - wallTop); ctx.clip();
          for (var ri = ripples.length - 1; ri >= 0; ri--) {
            var rp = ripples[ri];
            rp.r += 70 * dt; rp.a -= 1.3 * dt;
            if (rp.a <= 0) { ripples.splice(ri, 1); continue; }
            ctx.strokeStyle = 'rgba(25,188,212,' + rp.a.toFixed(3) + ')';
            ctx.lineWidth = 1.5;
            ctx.beginPath(); ctx.arc(rp.x, rp.y, rp.r, 0, 6.2832); ctx.stroke();
          }
          ctx.restore();
        }

        for (var i = crystals.length - 1; i >= 0; i--) {
          var c = crystals[i];
          if (conditioning && !c.treated && c.x >= fieldX) {
            c.treated = true;
            ripples.push({ x: c.x, y: c.y, r: 5, a: 0.5 });
            fieldGlow = Math.min(1, fieldGlow + 0.35);
          }
          c.x += c.vx * dt;
          if (c.treated) {
            c.morph = Math.min(1, c.morph + dt * 2.6);
            var m = easeOut(c.morph);
            c.rot += dt * 2.6 * m;
            var w = 12 + (c.nLen - 12) * m, h2 = 12 + (5 - 12) * m;
            ctx.save(); ctx.translate(c.x, c.y); ctx.rotate(c.rot * m);
            ctx.fillStyle = lerpCol(0xB0742E, 0x0E8FA6, m);
            rrect(ctx, -w / 2, -h2 / 2, w, h2, 1 + m * 1.5); ctx.fill();
            if (m > 0.6) {
              ctx.strokeStyle = 'rgba(255,255,255,' + (0.35 * (m - 0.6) / 0.4).toFixed(3) + ')';
              ctx.lineWidth = 1;
              ctx.beginPath(); ctx.moveTo(-w / 2 + 2, 0); ctx.lineTo(w / 2 - 2, 0); ctx.stroke();
            }
            ctx.restore();
          } else {
            if (!conditioning) {
              var ty = c.destWall === 'top' ? wallTop + 8 : wallBot - 8;
              c.y += (ty - c.y) * Math.min(1, dt * 1.6);
              if (c.x > 20 && Math.abs(c.y - ty) < 5) { addCrust(c.x, c.destWall); crystals.splice(i, 1); continue; }
            }
            var sz = c.size, wob = Math.sin(c.x * 0.05 + c.seed) * 0.12;
            ctx.save(); ctx.translate(c.x, c.y); ctx.rotate(wob);
            ctx.fillStyle = '#B0742E'; ctx.strokeStyle = '#8A571C'; ctx.lineWidth = 1;
            ctx.fillRect(-sz / 2, -sz / 2, sz, sz); ctx.strokeRect(-sz / 2, -sz / 2, sz, sz);
            ctx.fillStyle = 'rgba(255,255,255,0.28)';
            ctx.fillRect(-sz / 2 + 1.5, -sz / 2 + 1.5, sz / 2 - 1.5, sz / 2 - 1.5);
            ctx.restore();
          }
          if (c.x > W + 20) crystals.splice(i, 1);
        }

        var sum = 0, n = crustTop.length;
        for (var gi = 0; gi < n; gi++) sum += crustTop[gi] + crustBot[gi];
        gaugeV = n ? Math.min(1, sum / (n * 2 * CRUST_FULL)) : 0;
      }
      return { resize: resize, draw: draw, setOn: function (v) { on = v; }, gauge: function () { return gaugeV; } };
    }

    var simA = makeSim(cvA, false, 0);   // without MagSert
    var simB = makeSim(cvB, true, 0.9);  // with MagSert; powers on 0.9s after start

    var toggle = document.getElementById('hiw-toggle');
    var stateLabel = document.getElementById('hiw-state');
    var readoutB = document.getElementById('hiw-readout-b');
    var gaugeA = document.getElementById('hiw-gauge-a');
    var gaugeB = document.getElementById('hiw-gauge-b');
    var nudge = document.getElementById('hiw-nudge');
    var switchWrap = toggle ? toggle.parentNode : null;
    var onReadout = (toggle && toggle.dataset.readoutOn) || 'MagSert inline · minerals flush through';
    var offReadout = (toggle && toggle.dataset.readoutOff) || 'MagSert off · scale building on the wall';
    var onLabel = (toggle && toggle.dataset.stateOn) || 'ON';
    var offLabel = (toggle && toggle.dataset.stateOff) || 'OFF';

    var hintTimer = 0, hinted = false;
    function clearHint() {
      hinted = true;
      if (hintTimer) { clearTimeout(hintTimer); hintTimer = 0; }
      if (nudge) nudge.hidden = true;
      if (switchWrap && switchWrap.classList) switchWrap.classList.remove('is-hint');
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        clearHint();
        var on = toggle.getAttribute('aria-pressed') !== 'true';
        toggle.setAttribute('aria-pressed', on);
        stateLabel.textContent = on ? onLabel : offLabel;
        readoutB.textContent = on ? onReadout : offReadout;
        simB.setOn(on);
      });
    }

    var gA = -1, gB = -1;
    function updateGauges() {
      var a = simA.gauge(), b = simB.gauge();
      if (gaugeA && Math.abs(a - gA) > 0.01) { gA = a; gaugeA.style.transform = 'scaleX(' + a.toFixed(3) + ')'; }
      if (gaugeB && Math.abs(b - gB) > 0.01) { gB = b; gaugeB.style.transform = 'scaleX(' + b.toFixed(3) + ')'; }
    }

    var last = 0, running = false, rafId = 0, started = false;
    function loop(t) {
      if (!last) last = t; var dt = (t - last) / 1000; last = t; if (dt > 0.05) dt = 0.05;
      simA.draw(dt); simB.draw(dt); updateGauges();
      rafId = requestAnimationFrame(loop);
    }
    function resizeAll() { simA.resize(); simB.resize(); }
    window.addEventListener('resize', resizeAll);

    var target = document.getElementById('hiw-rig-b');
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && !running) {
          running = true; last = 0;
          if (!started) {
            started = true; resizeAll();
            if (!hinted) {
              hintTimer = setTimeout(function () {
                hintTimer = 0;
                if (nudge) nudge.hidden = false;
                if (switchWrap && switchWrap.classList) switchWrap.classList.add('is-hint');
              }, 4000);
            }
          }
          rafId = requestAnimationFrame(loop);
        } else if (!e.isIntersecting && running) {
          running = false; cancelAnimationFrame(rafId);
        }
      });
    }, { threshold: 0.2 });
    if (target) obs.observe(target);
  }

  if (document.readyState !== 'loading') initHIW();
  else document.addEventListener('DOMContentLoaded', initHIW);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#hiw-cv-a')) initHIW();
  });
})();
